// extracted by mini-css-extract-plugin
module.exports = {"container":"_3IP-B_nOamWFUHUrvdQz8E","groupsList":"_2bx2eNxKjyqj5S1E0TOkfK"};